// extracted by mini-css-extract-plugin
module.exports = {"sticker__animation":"sticker_sticker__animation__h16ka","sticker-animation":"sticker_sticker-animation__0vXa4"};